import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import styles from './PrecisionHotspot.module.scss';

const cx = classNames.bind(styles);

const PrecisionHotspot = ({
  wrapperClassname,
  ledClassname,
  position,
  isHidden,
  children
}) => {
  const hotspotClasses = cx(
    styles['precision-hotspot__led'],
    {
      [styles['precision-hotspot__item--left']]: position === 'left',
      [styles['precision-hotspot__item--hidden']]: isHidden
    },
    ledClassname
  );

  return (
    <div
      className={`${styles['precision-hotspot__wrapper']} ${wrapperClassname}`}
    >
      {children}
      <span className={hotspotClasses} />
    </div>
  );
};

PrecisionHotspot.propTypes = {
  wrapperClassname: PropTypes.string,
  ledClassname: PropTypes.string,
  position: PropTypes.string,
  isHidden: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ]).isRequired
};

PrecisionHotspot.defaultProps = {
  wrapperClassname: '',
  ledClassname: '',
  position: '',
  isHidden: false
};

export default PrecisionHotspot;
